import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  bcpDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './delete-workstations-dialog.controller';
import template from './delete-workstations-dialog.html';

class dialogService {
  getOptions($event, { assessmentId, workstations }) {
    return {
      controller,
      controllerAs: 'deleteWorkstationsDialogVM',
      locals: {
        assessmentId,
        workstations
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.workstations.deleteWorkstationsDialog', [
  ngCookies,
  constants,
  bcpDataService,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
])
  .service('deleteWorkstationsDialog', dialogService)
  .name;
